import React, { useContext } from 'react';
import {
  TaskCreationAction,
  TaskCreationWrapper,
} from './TaskCreation/TaskCreationWrapper';
import {
  TaskCreationForm,
  TaskCreationFormInterfaceType,
} from './TaskCreation/TaskCreationForm';
import TaskCreationContext from './TaskCreation/Context';
import { Card } from '@vimily/bonjoro-ui-components-v2/Card';
import Lottie from 'react-lottie';
import qs from 'query-string';
import cx from 'classnames';

const csvImageUrl = 'https://cdn.bonjoro.com/assets/icons/csv-grey.png';

import integrationAnimationData from '~/lotties/onboarding/integration-tasklist2022.json';
import { AnimatedDiv } from '@vimily/bonjoro-ui-components-v2/AnimatedDiv';

const cardClassName = 'w-full cursor-pointer p-5 flex gap-5';

export default function NoTask() {
  const { workspace } = useContext(TaskCreationContext);

  const onUploadCsvClick = () => {
    window.location.href = `/contacts/csv?${qs.stringify({
      campaign: workspace?.uuid,
    })}`;
  };

  const onIntegrationClick = () => {
    window.location.href = '/automation';
  };

  return (
    <TaskCreationWrapper>
      <AnimatedDiv
        show
        className='py-[30px] max-w-[1434px] w-full gap-5 flex flex-col min-[1100px]:flex-row text-center justify-center'
      >
        <div className='w-full min-[1100px]:w-1/2 flex flex-col gap-y-5 text-start'>
          <span className='text-[28px] v2-text-neutral-900 font-bold'>
            Send a new message
          </span>
          <span className='text-base v2-text-neutral-900'>
            Add someone&apos;s contact details to send them a video message
          </span>
          <TaskCreationForm
            actions={[
              TaskCreationAction.RecordLater,
              TaskCreationAction.RecordNow,
            ]}
            interfaceType={TaskCreationFormInterfaceType.Portrait}
            className='!py-[30px] !px-5 rounded-md v2-bg-neutral-50'
            actionPanelClassName='!justify-end !m-0'
            dropdownWidth={450}
          />
        </div>
        <div className='w-full min-[1100px]:w-1/2 text-start flex flex-col justify-between gap-y-5'>
          <span className='text-[28px] v2-text-neutral-900 font-bold'>
            Populate your tasklist
          </span>
          <Card
            className={cx(
              cardClassName,
              'px-[85px] py-[35px] flex-col items-center justify-center'
            )}
            onClick={onIntegrationClick}
          >
            <span>
              <Lottie
                options={{
                  animationData: integrationAnimationData,
                  ...{
                    loop: true,
                    autoplay: true,
                    rendererSettings: {
                      preserveAspectRatio: 'xMidYMid slice',
                    },
                  },
                }}
                height={218}
                width={300}
              />
            </span>
            <span className='text-[21px] font-bold text-center'>
              Connect an integration to automate your list
            </span>
          </Card>
          <Card
            className={cx(
              cardClassName,
              'flex-row p-5 items-start justify-start'
            )}
            onClick={onUploadCsvClick}
          >
            <img className='h-[50] w-[44px]' src={csvImageUrl} />
            <div className='flex flex-col gap-y-5 items-start'>
              <span className='text-[21px] font-bold'>Upload CSV</span>
              <span className='text-base font-thin text-start'>
                Upload CSV to upload existing contacts to your tasklist
              </span>
            </div>
          </Card>
        </div>
      </AnimatedDiv>
    </TaskCreationWrapper>
  );
}
